module.exports = __webpack_public_path__ + "media/img/fax-dc9499375a6cbd7b0cf5535181f62cc0.jpg";